import React, { useEffect, useRef } from "react";

/*
 * Shown on arrival, on every tab, whenever something stops this sequence
 * sending. Deterministic, so it is on screen with the page rather than seconds
 * later, and silent when there is nothing wrong.
 */
const SequenceBlockerStrip = props => {
  const { blocker = null, onAction = () => {}, onExplain = () => {} } = props || {};
  const ref = useRef(null);

  // The contacts/analytics tables size themselves off a 100%-height parent with
  // hardcoded pixel offsets. Adding a banner above them pushes the table past
  // the fold, so publish our real height and let the SCSS subtract it.
  useEffect(() => {
    const el = ref.current;
    const px = el ? Math.ceil(el.getBoundingClientRect().height) + 14 : 0;
    document.documentElement.style.setProperty("--sgBlockerStripH", `${px}px`);
    return () =>
      document.documentElement.style.setProperty("--sgBlockerStripH", "0px");
  }, [blocker && blocker.code, blocker && blocker.text]);

  if (!blocker) return null;

  return (
    <div
      ref={ref}
      className={`seqBlockerStrip ${blocker.severity || "bad"}`}
      role="status"
    >
      <span className="sbsDot" />
      <span className="sbsMsg">
        <b>{blocker.title}</b> {blocker.text}
      </span>
      <button type="button" className="sbsBtn" onClick={() => onAction(blocker)}>
        {blocker.actionLabel}
      </button>
      <button type="button" className="sbsBtn ghost" onClick={() => onExplain(blocker)}>
        Why?
      </button>
    </div>
  );
};

export default SequenceBlockerStrip;
